import React, { useEffect, useState, useRef } from 'react'
import { useQuery } from 'react-query'
import { useDebouncedCallback } from 'use-debounce'
import { getResourceList } from '../../models/BaseModel'
import { ImageReplacementAnchor, InlineNavigation, Loading, LogoNavigation, DrawerNavigation, BlankErrorBoundary } from '@scrippsproduct/scripps-external-component-library'

import './../../scss/Header.scss'

export default function Header() {
    const [menuLinks, setMenuLinks] = useState([])
    const [logoItems, setLogoItems] = useState([])
    const {isLoading, isSuccess, isError, data} = useQuery(['header', {resourceName: 'header'}], getResourceList)
    const mobileNavRef = useRef()

    useEffect(() => {
        if (isSuccess) {
            setMenuLinks(data.get('menuLinks'))
            setLogoItems(data.get('logoItems'))
        }
    }, [isError, isSuccess, data])

    const handleScroll = useDebouncedCallback(() => {
        if (window.scrollY > 10) {
            mobileNavRef.current.classList.add('mobile-nav--shadow');
        } else {
            mobileNavRef.current.classList.remove('mobile-nav--shadow');
        }
        }, 300) 

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    
    return (
        <header>
            <content-constrainer class="desktop-nav">
                <ImageReplacementAnchor href={`/`} 
                    image={{
                        url: 'https://ewscripps.brightspotcdn.com/76/c2/8d977ad74b48abc1c251eefd71d4/90-1.webp', 
                        width: 380, 
                        height: 250,
                    }} 
                    height={4.8}
                    baselineAdjustment={0.2}
                />
                { (isLoading) && <Loading />}
                <header-menu-wrapper>
                    { (isSuccess && menuLinks.length > 0) && 
                        <BlankErrorBoundary>
                            <InlineNavigation 
                                links={menuLinks} 
                                classname="main-navigation" 
                                position='right'
                            />
                        </BlankErrorBoundary>
                    } 
                    { (isSuccess && logoItems?.length > 0) && 
                        <LogoNavigation 
                            items={logoItems}
                        />
                    }
                </header-menu-wrapper>
            </content-constrainer>
            <nav className="mobile-nav" ref={mobileNavRef}>
                <content-constrainer class="content-constrainer--no-border">
                    <BlankErrorBoundary>
                        { (isSuccess && menuLinks.length > 0 && logoItems?.length > 0) && 
                            <DrawerNavigation
                                links={[
                                    {
                                        type: 'internal-link',
                                        href: '/',
                                        label: 'Home',
                                    },
                                    ...menuLinks]} 
                                items={logoItems}
                                logo={{
                                    image: {
                                        url: 'https://ewscripps.brightspotcdn.com/76/c2/8d977ad74b48abc1c251eefd71d4/90-1.webp', 
                                        width: 380, 
                                        height: 250,
                                    },
                                    href: process.env.REACT_APP_BASE_URL,
                                    height: 3.3,
                                    baselineAdjustment: 0.1
                                }}
                                classname="main-navigation"
                                clipPathStart="polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"
                                clipPathEnd="polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
                                overlayAppendEl={document.querySelector('site-wrapper')}
                            /> 
                        }
                    </BlankErrorBoundary>
                </content-constrainer>
            </nav>
        </header>
    )
}
